import React, { Fragment } from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { get, kebabCase } from 'lodash';
import type { FieldProps } from 'formik';
import 'formik';
import { getInputClasses, getValidationStatus } from 'Components/frameworks/formik/inputsUtils';
import { ErrorNote } from './ErrorNote';
import { Label } from './Label';
type Props = FieldProps & {
  dataTestId?: string;
  hideErrorMessage: boolean;
  isDisabled?: boolean;
  isRequired?: boolean;
  label?: string;
  maxLength?: number;
  placeholder?: string;
};
export const Textarea = ({
  dataTestId,
  field,
  form,
  hideErrorMessage,
  isDisabled = false,
  isRequired = false,
  label,
  maxLength,
  placeholder,
}: Props) => {
  // Textarea value defaults to empty string
  const value = get(form.values, field.name, '');
  const { isDefaultState, isErrored, isValidated } = getValidationStatus(
    { ...field, value },
    form,
    isDisabled,
  );
  const errorNoteId = `error-${kebabCase(field.name)}`;
  const classes = getInputClasses({
    hasRadius: false,
    isDefaultState,
    isDisabled,
    isErrored,
    isValidated,
  });
  return (
    <Fragment>
      {!!label && (
        <Label
          className="mx-15 mb-5"
          htmlFor={field.name}
          isErrored={isErrored}
          isRequired={isRequired}
          label={label}
        />
      )}
      <textarea
        aria-describedby={errorNoteId}
        autoComplete="off"
        className={classnames(classes, 'rounded-12')}
        data-testid={dataTestId}
        disabled={isDisabled}
        id={field.name}
        maxLength={maxLength}
        {...(placeholder
          ? {
              placeholder,
            }
          : null)}
        {...field}
        value={value}
      />
      {!hideErrorMessage && (
        <ErrorNote
          className="mx-15"
          errorMessage={form.errors[field.name] as string | undefined}
          errorNoteId={errorNoteId}
          isErrored={isErrored}
        />
      )}
    </Fragment>
  );
};
